import React from 'react';
import Button, { IButtonProps } from '@components-clean/legacy/core/button/button';

const SaveButton = (props: IButtonProps) => {
    const { id, 'data-testid': testId } = props;

    if (!testId && id) {
        props = {
            ...props,
            'data-testid': id,
        };
    }

    return <Button secondary {...props} />;
};

export default SaveButton;
